import { Qualification, QualificationCreatePayload, QualificationUpdatePayload } from '../types';
import { api } from '../../../../core/utils/apiClient';

export class QualificationsService {
  async listQualifications(activeOnly: boolean = true): Promise<Qualification[]> {
    try {
      const response = await api.get(`/api/v1/companies/qualifications?active_only=${activeOnly}`);
      if (response.ok) {
        const data: Qualification[] = await response.json();
        return Array.isArray(data) ? data : [];
      }
      return [];
    } catch (error) {
      console.error('Error fetching qualifications:', error);
      return [];
    }
  }

  async createQualification(payload: QualificationCreatePayload): Promise<Qualification | null> {
    const response = await api.post('/api/v1/companies/qualifications', payload);
    if (response.ok) {
      return await response.json();
    }
    const body = await response.json().catch(() => ({}));
    throw new Error(body?.detail || `HTTP ${response.status}`);
  }

  async updateQualification(id: number, payload: QualificationUpdatePayload): Promise<Qualification | null> {
    const response = await api.put(`/api/v1/companies/qualifications/${id}`, payload);
    if (response.ok) {
      return await response.json();
    }
    const body = await response.json().catch(() => ({}));
    throw new Error(body?.detail || `HTTP ${response.status}`);
  }

  async deleteQualification(id: number): Promise<void> {
    const response = await api.delete(`/api/v1/companies/qualifications/${id}`);
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body?.detail || `HTTP ${response.status}`);
    }
  }
}

export const qualificationsService = new QualificationsService();
